import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom'
import { Column } from '@ant-design/plots';
import { Button, Row, Col, Form, setParamsFilter, ProTableOt as ProTable_ot, useProTableOt, DemoProTableOt, message, Modal } from "../../../../../templates/my-app/src/components/ui/ot"
import { useSmartTaskSchedulingTaskPriority } from "../pmis/controller/smart_task_scheduling_task_priority_controller";
import { useTranslation } from 'react-i18next';
import PriorityModal from './smart_task_scheduling_task_priority_modal';



const SmartTaskSchedulingTaskPriorityTable = ({
    edit = true,
    api = `/pmis/smart_task_scheduling/task_priority`,
    onCheckTesk = () => { },
    modalFlag = 0,
    keyPrefix = "pmis.smartTaskSchedulingTaskPriority",
    onSelectChange = () => { },
    defaultSelectedRowsInfo = [],
    defaultSelectedRowsKeys = [],
    ...props
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const columns = [
        {
            title: t('index'),
            sorter: false,
            dataIndex: 'key',
            key: 'key',
            width: "10rem",
            // copyable: true,
        },
        {
            title: t('priority_name'),
            sorter: false,
            dataIndex: 'priority_name',
            key: 'priority_name',
            width: "10rem",
            // copyable: true,
        },
        // {
        //     title: t('priority_hex_color'),
        //     sorter: false,
        //     dataIndex: 'priority_hex_color',
        //     key: 'priority_hex_color',
        //     width: "10rem",
        //     // copyable: true,
        // },
        {
            title: t('action'),
            dataIndex: '操作',
            sorter: false,
            key: '操作',
            fixed: "right",
            disabled: true,
            width: "4rem",
            render: (_, record) => {
                return (
                    <Row gutter={[8, 8]}>
                        <Col span={12}>
                            <Button
                                variant={"table_row_clean_button"}
                                style={{
                                    color: '#2BC17B'
                                }}
                                onClick={() => {
                                    handleEditRow(record)
                                }}
                            >
                                {t('edit')}
                            </Button>
                        </Col>
                        <Col span={12}>
                            <Button
                                variant={"table_row_clean_button"}
                                style={{
                                    color: "#ff0000"
                                }}
                                onClick={() => handleDeleteRow(record?.priority_id)}
                            >
                                {t('delete')}
                            </Button>
                        </Col>
                    </Row>
                )
            }
        }
    ]
    const actionRef = useRef(null)
    const [checkTask, setCheckTask] = useState([])
    const [selectedRowsInfo, setSelectedRowsInfo] = useState(defaultSelectedRowsInfo)
    const [selectedRowKeys, setSelectedRowKeys] = useState(defaultSelectedRowsKeys)
    const [extra_columns, set_extra_columns] = useState([]);
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = []
            let selectRow = []
            select_temp = [...selectedRowKeys]
            selectRow = [...selectedRowsInfo]

            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value.task_id)
                    selectRow.push(value)
                })

            }
            else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value.task_id);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);

                })
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)

        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = []
            let selectRow = []
            select_temp = [...selectedRowKeys]
            selectRow = [...selectedRowsInfo]

            if (selected) {
                select_temp.push(record.task_id)
                selectRow.push(record)
            }
            else {
                select_temp = select_temp.filter(key => key !== record.task_id)
                selectRow = selectRow.filter(row => row.task_id !== record.task_id)
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)

        },
        getCheckboxProps: (record) => ({
            // disabled: record.pass === null,
        }),
    };

    const [modalOpen, setModalOpen] = useState(false)
    const [modalLoading, setModalLoading] = useState(false)
    const [form] = Form.useForm();
    const [axiosMode, setAxiosMode] = useState("get")

    const handleAddRow = () => {
        setAxiosMode("post")
        setModalOpen(true)
        form.resetFields()
    }
    const handleEditRow = (record) => {
        setAxiosMode("patch")
        setModalOpen(true)

        form.resetFields()
        form.setFieldsValue({
            ...record,
        })
    }
    const handleDeleteRow = (id) => {
        /* 刪除單／多筆資料 */
        let data = []
        /* 將PK做成陣列 */
        if (id) {
            /* 當單筆刪除時會帶入id */
            data = [{
                priority_id: id
            }]
            /* 放入欲刪除的陣列 */
        }

        else {
            data = selectedRowsInfo.map((val) => {
                /* 將已勾選的資料遍歷 */
                return {
                    priority_id: val?.priority_id
                }
                /* 取出pk放回陣列 */
            })
        }
        if (data.length > 0) {
            /* 防呆未勾選任何資料 */
            Modal.confirm({
                /* 一次性使用Modal且有確定與取消的按鈕 */
                content: '確定要刪除嗎？',
                /* modal內容 */
                onOk: () => {
                    deleteSmartTaskSchedulingTaskPriorityData(data)
                    /* 當按下確定後觸發刪除資料 */
                },
                okText: '確定',
                /* 確定的按鈕顯示的文字 */
                cancelText: '取消',
                /* 取消的按鈕顯示的文字 */
                contentStyle: {
                    zindex: 99,
                }
            })
        }
        else {
            message.info("請選擇項目")
            /* 一次性呈現上方提示字 */
        }
    }

    const onFormFinish = (values) => {
        if (axiosMode === "post") {
            postSmartTaskSchedulingTaskPriorityData([values])
        }
        else if (axiosMode === "patch") {
            patchSmartTaskSchedulingTaskPriorityData([values])
        }
    }

    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功")
                actionRef.current.reloadAndRest();

            }
            else if (axiosMode === "patch") {
                message.success("修改成功")
                actionRef.current.reloadAndRest();

            }
            else if (axiosMode === "delete") {
                message.success("刪除成功")
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([])
                setSelectedRowsInfo([])

            }
            setModalLoading(false)
            setModalOpen(false)
        }
        else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗")
                // actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "patch") {
                message.error("修改失敗")
                // actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "delete") {
                message.error("刪除失敗")
                // actionRef.current.reloadAndRest();
            }
            // setModalLoading(false)
            // setModalOpen(false)
        }
    }
    const onBefore = ({ axiosMode, status, values }) => {
        // setModalLoading(true)
    }

    const { 
        getSmartTaskSchedulingTaskPriorityData,
        postSmartTaskSchedulingTaskPriorityData,
        patchSmartTaskSchedulingTaskPriorityData,
        deleteSmartTaskSchedulingTaskPriorityData,
    } = useSmartTaskSchedulingTaskPriority({
        onFinish,
        onBefore,
    });
    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
        transferColumnAntdToShadcn,
        transferSortAntdToShadcn
    } = useProTableOt({
        columns
    })
    useEffect(() => {
        onCheckTesk(checkTask)
    }, [checkTask])

    useEffect(() => {
        checkAll()
    }, [])
    useEffect(() => {
        onSelectChange(selectedRowsInfo)
    }, [selectedRowsInfo])


    return (
        <Row gutter={[8, 8]}>
            <PriorityModal
                axiosMode={axiosMode}
                propsOpen={modalOpen}
                propsSetOpen={setModalOpen}

                propsForm={form}

                propsLoading={modalLoading}
                propsSetLoading={setModalLoading}
                onFinish={onFormFinish}
            />
            <Col span={24}>
                <ProTable_ot
                    actionRef={actionRef}
                    columns={columns}
                    check={check}
                    setCheck={setCheck}
                    headerTitle={<></>}
                    rowKey={'priority_id'}
                    request={async (params = {}, sort, filter) => {
                        let newParams = {
                        };
                        let order = setOrders(sort)
                        newParams = {
                            ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                            ...newParams,
                            order,
                            size: params.pageSize,
                            cur_page: params.current,
                            custom_filter_value: params.keyword,
                            custom_filter_key: custom_filter_key
                        }
                        newParams = {
                            ...newParams,
                        }
                        newParams = setParamsFilter({
                            ...newParams,
                        });
                        return getSmartTaskSchedulingTaskPriorityData({
                            ...newParams
                        })
                    }}
                    rowSelection={{
                        type: 'checkbox',
                        selectedRowKeys: selectedRowKeys,
                        ...rowSelection,
                    }}
                    extra_columns={extra_columns}
                    set_extra_columns={set_extra_columns}
                    manage_columns={false}
                    scroll={{
                        x: "100vw"
                    }}
                    toolBarRender={() => [
                        <Button
                            type={'primary'}
                            onClick={() => handleAddRow()}
                        >
                            {t('post_priority')}
                        </Button>,
                        <Button
                            variant={"batchDelete"}
                            onClick={() => handleDeleteRow()}
                        >
                            {t('delete_multiple')}
                        </Button>,
                    ]}
                />
            </Col>
        </Row >
    )
}
const SmartTaskSchedulingTaskPriority = ({
    propsForm,
    onFormFinish = () => { },
    defaultSelectedRowsInfo = [],
    defaultSelectedRowsKeys = [],
    ...props
}) => {
    const [form_] = Form.useForm();
    const form = propsForm || form_
    const getFormValues = () => {
        let values = {}
        values = form.getFieldsValue()
        return values
    }
    const onFinish = () => {
        const values = getFormValues();
        onFormFinish({
            ...values,
        })
    }
    const onSelectChange = (selectedRowsInfo) => {
        form.setFieldsValue({ selectedRowsInfo: selectedRowsInfo })
    }
    return (
        <Row>
            <Col span={24}>
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    form={form}
                    onValuesChange={() => { }}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name={"selectedRowsInfo"}
                                hidden={true}
                            >
                            </Form.Item>
                            <SmartTaskSchedulingTaskPriorityTable
                                defaultSelectedRowsInfo={defaultSelectedRowsInfo}
                                defaultSelectedRowsKeys={defaultSelectedRowsKeys}
                                onSelectChange={onSelectChange}
                            />
                        </Col>
                    </Row>
                </Form>
            </Col>
        </Row>
    )
}
export { SmartTaskSchedulingTaskPriorityTable }
export default SmartTaskSchedulingTaskPriority;
